/* eslint no-useless-escape: 0 */

const sv = "A cold drop on my lip\nAcross my fingertips I feel it\nInstincts fire and spit\nPeel back my consciousness, just feel it\nDriven into the earth\nUnder a mound of weight I'm dreaming\nThrough the mud and the dirt\nTilt your head just right, I'm screaming\nThe light it penetrates\nMy eyelids the boulder, rolling\nMy eyes dilate\nMy skin spikes and shakes, I'm feeling\nInstincts remonstrate\nAcross the wilderness I'm running"

export default sv;
